import request from './request/request'

// import url from './url'

// const defaultApi = {
//     getHelpActicleListForPc: function(data){
//         return request({
//             url:'/HelpWS/getHelpActicleListForPc.help',
//             method:'get',
//             params:{
//                 ...data
//             }
//         })
//     },
// }
// export default defaultApi

// 查询文章列表
export async function getHelpActicleListForPc(data) {
    const option = {
        url: '/HelpWS/getHelpActicleListForPc.help',
        method: 'post',
        params:data
    }
    return request(option)
}
// 增加
export async function getHelpActicleTypeListForPc(data) {
    const option = {
        url: '/HelpWS/getHelpActicleTypeListForPc.help',
        method: 'get',
        params:data
    }
    return request(option)
}


// 获取文章详情
export async function getHelpActicleByNumberCodeForPc(data) {
    const option = {
        url: '/HelpWS/getHelpActicleByNumberCodeForPc.help',
        method: 'post',
        params:data
    }
    return request(option)
}

//给文章添加浏览数
export async function addHelpActicleBrowseNumForPc(data) {
    const option = {
        url: '/HelpWS/addHelpActicleBrowseNumForPc.help',
        method: 'post',
        params:data
    }
    return request(option)
}

//给文章添加有用数
export async function addHelpActicleUsefulReviewNumForPc(data) {
    const option = {
        url: '/HelpWS/addHelpActicleUsefulReviewNumForPc.help',
        method: 'get',
        params:data
    }
    return request(option)
}
//给文章添加无用数
export async function addHelpActicleUnusefulReviewNumForPc(data) {
    const option = {
        url: '/HelpWS/addHelpActicleUnusefulReviewNumForPc.help',
        method: 'get',
        params:data
    }
    return request(option)
}



